import "./hero.scss";
import { useTranslation } from "react-i18next";

const Hero = () => {
  const { t } = useTranslation();
  return (
    <section className="hero">
      <div className="hero-badge">
        <span className="badge-dot"></span>
        {t("hero_badge")}
      </div>
      <h1 className="hero-h1">
        {t("hero_title_1")}{" "}
        <span className="hero-accent">{t("hero_title_2")}</span>
        <br />
        {t("hero_title_3")}
      </h1>
      <p className="hero-sub">{t("hero_sub")}</p>
      <div className="hero-actions">
        <a href="tel:+995557396727" className="btn-primary">
          {t("hero_btn_call")}
        </a>
        <a href="#services" className="btn-secondary">
          {t("hero_btn_services")}
        </a>
      </div>
      <div className="hero-stats">
        <div className="stat">
          <span className="stat-num">500+</span>
          <span className="stat-label">{t("stat_jobs")}</span>
        </div>
        <div className="stat">
          <span className="stat-num">4.9 ★</span>
          <span className="stat-label">{t("stat_rating")}</span>
        </div>
        <div className="stat">
          <span className="stat-num">3+</span>
          <span className="stat-label">{t("stat_experience")}</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
